<template>
  <div class="w-100 bg-gray20">
    <div class="container d-flex fd-column SECTION">
      <div class="SECTION-TITLE h3 text-bold text-center p-x-1:mo p-b-2">
        <div>{{content.title}}</div>
      </div>
      <img
          v-if="!$device.isMobileOrTablet"
          class="IMAGE as-end as-center"
          :src="image"
          :alt="altText"
      />
      <div class="d-flex fd-column ITEM-SECTION" >
        <div
            v-for="(item, index) in content.items"
            :key="index"
            class="ITEM"
        ><how-to-join-item
            :item= item
            @modal-open="onModalOpen"/>
        </div>
      </div>
      <checklist-modal
          v-if="activeModal"
          :is-open="isChecklistModalOpened"
          @close="onModalClose"
          :modal="activeModal"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ChecklistModal from './components/ChecklistModal';
import HowToJoinItem from './components/HowToJoinItem';

export default {
  name: 'how-to-join-checklist',
  components: {
    HowToJoinItem,
    ChecklistModal,
  },
  data () {
    return {
      isChecklistModalOpened: false,
      activeModal: null,
    };
  },
  computed: {
    ...mapGetters('homepage/contentful', [
      'proHomePage',
    ]),
    content () {
      return this.proHomePage.toJoinChecklist;
    },
    image () {
      return this.content.image.fields.file.url;
    },
    altText () {
      return this.content.image.fields.description;
    },
  },
  methods: {
    onModalOpen (modal) {
      this.isChecklistModalOpened = true;
      this.activeModal = modal;
    },
    onModalClose () {
      this.isChecklistModalOpened = false;
      this.activeModal = null;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
  .SECTION {
    padding-bottom: 12 * $unit;
  }
  .SECTION-TITLE {
    margin-top: 8* $unit;
  }
  .ITEM-SECTION {
    margin-top: $unit * 10;
    max-width: 759px;
    padding: 0px 8px;
    background-color: white;
    margin-bottom: 8 * $unit;
    z-index: 10;
  }
  .ITEM {
    border-bottom: solid 1px $color-gray40;
  }
  .ITEM:nth-last-child(1) {
      border-bottom: unset;
    }
  .IMAGE {
    position: absolute;
    margin-top: $unit * 18;
    max-width: 806px;
    height: auto;
    width:100%;
    display: flex;
    flex: 1 1 auto;
  }
</style>
